import { SaveBase } from "./SaveBase";
export class SaveStyle {
    constructor() {
    }
    isSaveMark() {
        return false;
    }
    restore(runner) {
        runner["_" + this._key] = this._fillStyle;
        runner._submitKey.other = this._other;
        SaveStyle.POOL[SaveStyle.POOL._length++] = this;
    }
    static save(runner, key) {
        let _saveMark = runner._saveMark;
        if ((_saveMark._saveuse & SaveBase.TYPE_STYLE) === SaveBase.TYPE_STYLE)
            return;
        _saveMark._saveuse |= SaveBase.TYPE_STYLE;
        let no = SaveStyle.POOL;
        let o = no._length > 0 ? no[--no._length] : (new SaveStyle());
        o._fillStyle = runner[key];
        o._other = runner._submitKey.other;
        o._key = key;
    }
}
SaveStyle.POOL = SaveBase._createArray();
